import { Box, Button, CloseButton, Collapse, Flex, Text } from "@chakra-ui/react"
import { useState } from "react"
import { infoMessageStorage } from "../../../../common/constants/browser-storage"
import { stringToHash } from "../../../../common/utils/common-utils"
import { CInfo } from "../../../shared/Icons"
import PrismicRtfLabel from "../../../shared/PrismicRtfLabel"

const InfoMessage = ({ messageProps }) => {
  const { title, content, button_text, button_url } = messageProps
  const [hasInfoMessageItem, setHasInfoMessageItem] = useState(!!localStorage.getItem(infoMessageStorage.KEY))
  const newInfoMessageHash = messageProps ? stringToHash(JSON.stringify(messageProps)) : ""

  /* If we have info message hash set in localStorage, compare the new info message hash with the hash from the old info message
  stored in localStorage, if they are different delete the old item and show the new message to the user */
  if (hasInfoMessageItem) {
    const oldInfoMessageHash = localStorage.getItem(infoMessageStorage.KEY)

    if (oldInfoMessageHash !== newInfoMessageHash) {
      localStorage.removeItem(infoMessageStorage.KEY)
      setHasInfoMessageItem(false)
    }
  }

  return (
    <Collapse in={!hasInfoMessageItem} unmountOnExit={true}>
      <Box as="section">
        <Flex
          flexDirection="column"
          alignItems="flex-start"
          gap={{ base: "4", sm: "6" }}
          bgColor="brand.50"
          px={{ base: "4", sm: "6", md: "8" }}
          py={{ base: "10", sm: "6", md: "8" }}
          my="10"
          position="relative"
        >
          <CloseButton
            w={{ base: "11", sm: "10" }}
            h={{ base: "11", sm: "10" }}
            top="4"
            right="4"
            position="absolute"
            onClick={() => {
              localStorage.setItem(infoMessageStorage.KEY, newInfoMessageHash)

              setHasInfoMessageItem(true)
            }}
          />

          <Flex flexDirection="column" gap="2">
            <Flex gap={{ base: "2", sm: "4" }} alignItems="flex-start">
              <CInfo />
              <Text lineHeight="1" fontSize={{ base: "lg", sm: "xl" }} pr="10" fontWeight="medium">
                {title}
              </Text>
            </Flex>
            <PrismicRtfLabel rtfValue={content} />
          </Flex>

          {button_text && (
            <Button
              as="a"
              href={button_url?.url}
              target={button_url?.target}
              w={{ base: "100%", sm: "auto" }}
              variant="primary"
            >
              {button_text}
            </Button>
          )}
        </Flex>
      </Box>
    </Collapse>
  )
}

export default InfoMessage
